export const Role = {
    "Admin": 0,
    "Manage": 1,
    "User": 2
}